import * as Stimulus from "@hotwired/stimulus"

export class DialogController extends Stimulus.Controller {
    static get targets() {
        return [ 'dialog', 'turboFrame' ];
    }

    dialogFromEvent(e) {
        const selector = e?.params?.selector;
        if (selector) {
            return document.querySelector(selector);
        }

        return this.dialogTarget;
    }

    closeIfClickedOutside(e) {
        // The HtmlDialogElement will only register as the target when the
        // background is clicked. Otherwise the element inside (i.e. the div)
        // will be the target.
        if(e.target instanceof HTMLDialogElement && e.target.open) {
            e.target.close();
        }
    }

    open(e) {
        const dialog = this.dialogFromEvent(e);
        if (dialog) {
            const url = e?.params?.url;
            if (url && this.hasTurboFrameTarget) {
                const frame = this.turboFrameTarget;
                if (frame.getAttribute("src") === url) {
                    frame.reload();
                } else {
                    frame.setAttribute("src", url);
                }
            }
            dialog.showModal();
        }
    }

    openIfFormValid(e) {
        const form = e.currentTarget.form;
        if (form && !form.reportValidity()) {
            return;
        }

        this.open();
    }

    close(e) {
        const dialog = this.dialogFromEvent(e);
        if (dialog?.open) {
            dialog.close();
        }
    }

    reloadFrames() {
        this.turboFrameTargets.forEach(($t) => {
           $t.reload();
        })
    }
}
